// ** MUI Imports
import { getCookie } from 'cookies-next'
import { EditorState, RawDraftContentState, convertToRaw } from 'draft-js'
import { GetServerSidePropsContext } from 'next'
import BookApi from 'src/@core/utils/api/book-api'
import BookViewPage from './[id]/[chapterNumber]'

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
  const token = getCookie('token', { req: context.req, res: context.res })
  if (token) {
    const options = { headers: { Authorization: `Bearer ${token}` } };
    const data = await BookApi.getUserBookChapterRead(context.query.id as string, options)

    return {
      redirect: {
        permanent: false,
        destination: `/book/${context.query.id}/${data.chapterNumber}/`
      }
    }
  } else {
    const bookId = context.query.id
    const chapterNumber = 1;
    const chapterList = await BookApi.getPublishedBookChapters(bookId)
    const book = await BookApi.getPublishedBook(bookId)
    const bookPage = await BookApi.getBookChapter(bookId, chapterNumber)
    let rawContent: RawDraftContentState = convertToRaw(EditorState.createEmpty().getCurrentContent())

    if (bookPage.content) {
      rawContent = bookPage.content as RawDraftContentState
      if (!rawContent.entityMap) {
        rawContent.entityMap = {}
      }
    }

    return { props: { chapterList, book, chapterNumber, rawContent } }
  }
}
export default BookViewPage
